module.exports = __webpack_public_path__ + "static/media/transfer-out.142c93fd.svg";